<div class="chart-container">
  <canvas #chartCanvas></canvas>
</div>
